import { count } from "@components/config/helpers";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import dynamic from "next/dynamic";

const CategorySlider = dynamic(() => import("./CategorySlider"));

const Wrapper = ({children}) => (<Box className="mb-3">{children}</Box>) 

const CategorySliderContainer = ({slides, loading = false}) => {

    if(count(slides) > 0){
        return (
            <Wrapper>
                {!loading ? <CategorySlider slides={slides} /> :<Skeleton animation="wave" variant="rectangular" width={'100%'} height={200} />}
            </Wrapper>
        )
    }

    return (
        <Wrapper>
            {loading && (
                <>
                    <Skeleton className="mt-4" animation="wave" variant="rounded" width={'18%'} height={45} />
                    <Skeleton className="mt-3" animation="wave" variant="rounded" width={'100%'} height={20} />
                    <Skeleton className="mt-2" animation="wave" variant="rounded" width={'20%'} height={20} />
                </>
            )}
        </Wrapper>
    )
}

export default CategorySliderContainer